import { FuzzyMap } from 'utils/fuzzy';

export const taskInfoFields = [
    'idSucursal',
    'asunto',
    'taskDate',
    'minutosAviso',
    'user',
    'idTipoGestion',
    'account',
    'contact',
    'idExpediente',
    'comment',
];

export const getTaskContactFieldSchema = (getLiteral) => ({
    id: 'contact',
    serverId: 'idContacto',
    fieldConfiguration: 'idcontacto',
    type: 'fuzzySearchSingle',
    mandatory: false,
    label: getLiteral('label_contact'),
    hint: getLiteral('label_contact'),
    inputAttrs: {
        ...FuzzyMap.contactos,
        parentField: 'idempresa',
        parentValueType: 'fuzzySearch',
        readOnlyIfNoParent: true,
        parentFieldForBackend: 'idempresa',
        parentFieldForContext: 'account',
    },
});
